/**
 * MainLayout — DS Layout
 * Layout principal : header fixe + main scrollable + footer optionnel
 */

import styles from './MainLayout.module.css';

interface MainLayoutProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function MainLayout({ header, footer, children, className = '' }: MainLayoutProps) {
  return (
    <div className={`${styles.root} ${className}`}>
      {header && <header className={styles.header}>{header}</header>}
      <main className={styles.main}>{children}</main>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </div>
  );
}
